module.exports = __webpack_public_path__ + "static/media/dragDropIcon.665ea049.svg";